import { lazy, Suspense, type ComponentProps } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { Sheet } from '../Sheet';

const loadEditor = () => import('./RecipeEditor');
const RecipeEditor = lazy(loadEditor);

/**
 * Starts loading the editor before it's needed (while an import runs, say), so it opens
 * without a gap. If this fails, opening it tries again and the error boundary below has it.
 */
export function preloadRecipeEditor(): void {
  loadEditor().catch((err: unknown) => console.warn('[recipes] Preloading the recipe editor failed:', err instanceof Error ? err.message : err));
}

/** The editor loads on first use, like the Log sheet. A chunk that fails to load (say after a rebuild) can't take the page down. */
export function LazyRecipeEditor(props: ComponentProps<typeof RecipeEditor>) {
  return (
    <ErrorBoundary
      fallback={() => (
        <Sheet title="Something went wrong" size="sm" onClose={props.onClose}>
          <div className="stack">
            <p className="small muted">The recipe editor couldn't open. Your recipes are saved.</p>
            <div className="row">
              <button className="btn btn--primary" onClick={() => window.location.reload()}>
                Reload
              </button>
              <button className="btn btn--ghost" onClick={props.onClose}>
                Close
              </button>
            </div>
          </div>
        </Sheet>
      )}
    >
      <Suspense fallback={null}>
        <RecipeEditor {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
